
import React, { Component } from 'react';
import ClippedBanger from './components/clippedBanger.js';
import BangerText from './components/bangerText.js';
import "./styles/hero.scss";
import Footer from "./components/footer";
import HoverGrowImage from './components/hoverGrowImage.js';
import  './utils/analytics';

export default class About extends Component {

  render() {
	var teamPhotos = [];

	for (var i=1; i<9; i++) {
		var image = "/images/team-"+i+".jpg";
    	teamPhotos.push(<div className="small-12 medium-3 tiny-padding"><HoverGrowImage image={image} /></div>);
	}
    return (
      <div>
        <div className="black-background">
          <ClippedBanger
			title="Innovation & Integrity"
            text="Two words we aim to emulate through our work. At Alpine Design, we strive for excellence. We breathe creativity. We code. We design. We work our tail feathers off. We laugh. And boy, do we play. Our passion drives our vision- to provide brands with incomparable quality and outstanding designs that are unique to their business. We craft impressions that last and have a damn good time doing so."
			backgroundImage="images/about-back-dark.jpg"
			height="full"
			/>
          </div>
		  <div className="medium-max-width-container">
			  <BangerText
					text="Based in the Silicon Valley we live and breath innovation. It is impossible to not be passionate about the most progressive technology in the world when you are surrounded by it."
				/>
			  <div id="photo-grid-collage" className="row" style={{lineHeight:0}}>
				<div className="small-12 medium-7" style={{textAlign:'right'}}>
					<img alt="" id="photo-grid-collage-1" className="full-width" src="/images/team-1.jpg" />
					<img alt="" id="photo-grid-collage-3" className="half-width" src="/images/team-2.jpg" />
				</div>
				<div className="small-12 medium-5">
					<img alt="" className="half-width" src="/images/team-3.jpg" style={{transform:'scale(1.3)'}} />
					<img alt="" id="photo-grid-collage-2" className="full-width" src="/images/team-4.jpg" />
					<img alt="" className="half-width" src="/images/team-5.jpg" style={{transform:'scale(1.3)'}}/>
					<img alt="" id="photo-grid-collage-4" className="half-width" src="/images/team-6.jpg" style={{transform:'scale(1.4)'}}/>
				</div>
			  </div>
		      <BangerText
					text="However, as much as we love where we live, we find our recharging escape in the mountains. It is in the alpine that our creative minds thrive."
				/>
			</div>
          <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/about.js